import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IssueWarrantyDTO } from '../../interfaces/warranty.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalConstruccionWarrantieComponent } from '../../modal-construccion-warrantie/modal-construccion-warrantie.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';

@Component({
  selector: 'app-table-issue-warranties',
  templateUrl: './table-issue-warranties.component.html',
  styleUrls: ['./table-issue-warranties.component.scss']
})
export class TableIssueWarrantiesComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true}) sort: MatSort;
  @Input() warranties: IssueWarrantyDTO[];
  @Input() page: number;
  @Input() pageSize: number;
  @Input() totalRows: number;
  @Input() sortColumn: string;
  @Input() sortDirection: string;
  @Output() pagination = new EventEmitter<any>;
  @Output() sorting = new EventEmitter<any>;
  @Output() notify = new EventEmitter<any>;
  public dataSource: MatTableDataSource<IssueWarrantyDTO>;
  public permissionForUpdateWarrantieBuild: boolean = false;

  public displayCols = [
    'WarrantyType',
    'InsuranceName',
    'EmissionDate',
    'ProviderRut',
    'ProviderName',
    'ProviderPhone',
    'ProviderEmail',
    'Amount',
    'AmountType',
    'Code',
    'TenderBuyerRut',
    'TenderBuyerName',
    'TenderCode',
    'DaysWarrantyDuration',
    'Status',
    'IsConstruccion'
  ];

  constructor(private dialog: MatDialog, private authService: AuthService){
    this.permissionForUpdateWarrantieBuild = this.authService.ValidateUserPermission('UpdateWarrantieIsBuild');
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.setDataSource();
    this.setSorting();
  }

  public changePagination(event: PageEvent) {
    const pagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.pagination.emit(pagination);
  }

  public changeSorting(sortState: Sort): void {
    if(sortState.direction === '') {
      this.sorting.emit(null);
      return;
    }

    const sorting =  {
      sortColumn: sortState.active,
      sortDirection: sortState.direction.toLowerCase()
    };
    this.sorting.emit(sorting);
  }

  private setDataSource() {
    this.dataSource.data = this.warranties;
    this.paginator.pageIndex = this.page -1;
    this.paginator.pageSize = this.pageSize;
    this.paginator.length = this.totalRows;
  }

  private setSorting() {
    this.sort.active = this.sortColumn;
    if(this.sortDirection)
      this.sort.direction = this.sortDirection === 'asc' ? 'asc': 'desc';
  }

  public openModalConstruccion(warrantie: any) {
    console.log("Data:", warrantie);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '30vw';
    dialogConfig.height = '32vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = warrantie;

    const dialogRef = this.dialog.open(ModalConstruccionWarrantieComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.notify.emit();
    })
  }

}